import React from 'react';
import PropTypes from 'prop-types';
import './AppTitle.scss';
import { Typography } from '@material-ui/core';

const AppBar = (props) => {
  const { configuration } = props;
  return (
    <div className="grb-breadcrumbs-toolbar">
      <Typography variant="h5">{configuration.getApplicationTitle()}</Typography>
    </div>
  );
};

AppBar.propTypes = {
  configuration: PropTypes.shape({ getApplicationTitle: PropTypes.func }).isRequired,
  authService: PropTypes.shape({
    acceptRoute: PropTypes.func.isRequired,
  }).isRequired,
  routeService: PropTypes.shape({
    getChildRoutes: PropTypes.func,
  }).isRequired,
};

export default AppBar;
